import { render, staticRenderFns } from "./payPromptModal.vue?vue&type=template&id=b3c10d4c&scoped=true&"
import script from "./payPromptModal.vue?vue&type=script&lang=js&"
export * from "./payPromptModal.vue?vue&type=script&lang=js&"
import style0 from "./payPromptModal.vue?vue&type=style&index=0&id=b3c10d4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c10d4c",
  null
  
)

export default component.exports